import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/drama";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setActive((v) => (v + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setActive((v) => (v + dir + total) % total);
  const slide = heroSlides[active];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden bg-foreground-950">
      {heroSlides.map((item, index) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-700 ${index === active ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={item.image}
            alt={`善良的小姨子 ${item.badge}`}
            title="善良的小姨子 高清剧集海报"
            className={`w-full h-full object-cover ${index === active ? "animate-zoom-slow" : ""}`}
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/60 to-foreground-950/20"></div>

      <div className="relative z-10 h-full w-full px-4 md:px-8 flex flex-col justify-center">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs md:text-sm font-medium mb-4">
            <i className="ri-fire-fill"></i>
            {slide.badge}
          </span>
          <h1 className="font-heading text-3xl md:text-6xl font-black text-background-50 leading-tight">
            {slide.title}
          </h1>
          <p className="text-background-200 text-sm md:text-lg mt-3 md:mt-4 max-w-xl leading-relaxed">{slide.subtitle}</p>

          <div className="flex flex-wrap items-center gap-3 mt-6 md:mt-8">
            <Link
              to={`/play/${slide.episodeNumber}`}
              className="inline-flex items-center gap-2 px-5 md:px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg"></i>
              立即观看 第{slide.episodeNumber}集
            </Link>
            <Link
              to="/detail"
              className="inline-flex items-center gap-2 px-5 md:px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-information-line text-lg"></i>
              查看剧情详情
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-6 md:mt-8 text-background-300 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-secondary-400"></i> 8.6 分
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line"></i> 每周三、周五更新
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-hd-line"></i> 高清画质
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => go(-1)}
        className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 items-center justify-center hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => go(1)}
        className="hidden md:flex absolute right-6 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 items-center justify-center hover:bg-background-50/30 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((item, index) => (
          <button
            key={item.id}
            type="button"
            aria-label={`切换到第${index + 1}张`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === active ? "w-8 bg-accent-500" : "w-4 bg-background-50/50 hover:bg-background-50/80"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}